/**
 * AppIcon — render ikon generated (PNG transparan, 3D clay) dengan
 * ukuran konsisten. Pengganti emoji teks (Fase 3 redesign).
 *
 * Selalu dekoratif: screen reader sudah membaca label teks di
 * sebelahnya, jadi accessibilityElementsHidden.
 */

import { Image, type ImageSourcePropType, type ImageStyle, type StyleProp } from 'react-native';

export type AppIconProps = {
  source: ImageSourcePropType;
  /** Sisi persegi dalam pt. Default 32. */
  size?: number;
  style?: StyleProp<ImageStyle>;
};

export function AppIcon({ source, size = 32, style }: AppIconProps) {
  return (
    <Image
      source={source}
      style={[{ width: size, height: size }, style]}
      resizeMode="contain"
      accessibilityElementsHidden
      importantForAccessibility="no"
    />
  );
}
